import { render, staticRenderFns } from "./CreateBusinessBundle.vue?vue&type=template&id=db6bd0c4"
import script from "./CreateBusinessBundle.vue?vue&type=script&lang=js"
export * from "./CreateBusinessBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db6bd0c4')) {
      api.createRecord('db6bd0c4', component.options)
    } else {
      api.reload('db6bd0c4', component.options)
    }
    module.hot.accept("./CreateBusinessBundle.vue?vue&type=template&id=db6bd0c4", function () {
      api.rerender('db6bd0c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/bundle/CreateBusinessBundle.vue"
export default component.exports